module.exports = __webpack_public_path__ + "749af60ade5e2100cb14d635b7b7abcc.jpg";